import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Google Analytics component for tracking page views in SPA
 * Sends a page view event to GA whenever the route changes
 */
export default function GoogleAnalytics() {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      const pagePath = location.pathname + location.search;
      window.gtag('config', 'G-W5XDNV3DFZ', { page_path: pagePath });
      window.gtag('config', 'G-573V3ZJ98B', { page_path: pagePath });
    }
  }, [location]);

  return null;
}
